import { render, staticRenderFns } from "./aboutus.vue?vue&type=template&id=8cc3db1e&scoped=true&"
import script from "./aboutus.vue?vue&type=script&lang=js&"
export * from "./aboutus.vue?vue&type=script&lang=js&"
import style0 from "./aboutus.vue?vue&type=style&index=0&id=8cc3db1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc3db1e",
  null
  
)

export default component.exports